
// region JS Imports

// region External Modules
import $ from "jquery"
import IntlTelInput from "plugins/intl_tel_input"
import serialize from "form-serialize"
import Pikaday from "plugins/pikaday/index"
import Formatter from "app/numbers/formatter"

import "bootstrap3-tooltip"
import "bootstrap3-popover"

import I18n from "plugins/i18n-js"
import * as Routes from "plugins/js-routes"
// endregion External Modules

// Private Modules
import Authentication_manager from "app/authentication/manager"
import MobileOsDetection from "app/detection/mobile_os"
import Authentication_remote_state from "app/authentication/remote_state"
import Notifier from "app/notifier/index"
import DataRetriever from "app/data_retriever"
import StickyNavbarHandler from "app/sticky_navbar_handler/index"
import Google_Event from "app/tracking/google/event"
import WaitObjectByPathPromise from "app/wait_object_by_path_promise"

import {
  ERROR_HANDLER_ACTIONS as AJAX_ERROR_HANDLER_ACTIONS,
  q_ajax_3,
} from "app/utils/q_ajax/q_ajax_3"

import GA4_Event from "app/tracking/google/google_analytics_4/event"
import PageInstance from "app/page_instance"

import { captureMessage } from "app/error_reporting/index"
// Private Modules

// region Public Components
// endregion Public Components

// region Private Components
// endregion Private Components

// endregion JS Imports


// Constants
const DEFAULT_SELECTOR = {
  scope:                            ".cell--cities--concierge--serviced--apartments",
  form:                             "form",
  area:                             ".cell--cities--concierge__form__region_select",
  budget:                           ".cell--cities--concierge__form__budget_range_select",
  reject_promotions_container:      ".cell--cities--concierge__form--footer--reject-promotions--container",
  reject_promotions:                ".cell--cities--concierge__form--footer--reject-promotions",

  indicator:                        ".cell--cities--concierge__submission_indicator",
  email:                            ".city_serviced_apartments_request_record_contact_email",
  submit:                           ".btn-serviced-apartment-submit__request",
  section:                          ".cell--cities--concierge__form--container",
  error_container:                  ".cell--cities--concierge__form--input-container--error",
  contact_phone_number_input:       ".cell--cities--concierge__contact-phone-number-input",
  contact_phone_number_dial_code:   ".iti__selected-dial-code",
  tooltip:                          ".cell--cities--concierge__form--tooltip",
  footer:                           ".cell--cities--concierge__form--footer",
}

interface InputOptions {
  popover_options?: Bootstrap3Popover.Options,
}

const DEFAULT_POPOVER_OPTIONS = {
  placement:  "auto",
}

const PAGE_EXPAND_CLASS = "page--filter--freeze"

enum ResultTypeEnums {
  SUCCESS =            "SUCCESS",
  INVALID =            "INVALID",
  TOO_MANY_REQUEST =   "TOO_MANT_REQUEST",
  RESOURCE_NOT_FOUND = "RESOURCE_NOT_FOUND",
}


const init = (options?: InputOptions) => {
  $(DEFAULT_SELECTOR.scope).each((idx, el) => {
    const $el = $(el)

    const $form = $el.find(DEFAULT_SELECTOR.form)
    const $section = $el.find(DEFAULT_SELECTOR.section)
    const $footer = $el.find(DEFAULT_SELECTOR.footer)

    const $reject_promotions_container = $el.find(DEFAULT_SELECTOR.reject_promotions_container)
    const $reject_promotions_input = $el.find(DEFAULT_SELECTOR.reject_promotions)

    const $area = $form.find(DEFAULT_SELECTOR.area)
    const $budget = $form.find(DEFAULT_SELECTOR.budget)
    const $indicator = $form.find(DEFAULT_SELECTOR.indicator)
    const $email = $form.find(DEFAULT_SELECTOR.email)
    const $tooltip = $el.find(DEFAULT_SELECTOR.tooltip)

    const $submit = $form.find(DEFAULT_SELECTOR.submit)

    const $contact_phone_number_input =
      $form.find(DEFAULT_SELECTOR.contact_phone_number_input)
    const city_id = DataRetriever.get("current-city-id")

    // Only show regions allowed by budget
    $budget.on("change", () => {
      const url = Routes.regions_city_serviced_apartments_path(I18n.locale, city_id, {
        budget_range_max: $budget.find("option:selected").data("budget-range-max"),
        budget_range_min: $budget.find("option:selected").data("budget-range-min"),
      })

      q_ajax_3(
        {
          url:      url,
          method:   "GET",
          dataType: "JSON",
        },
        {
          custom_error_handler: ({http_status_code}) => {
            switch (http_status_code) {
              case 404:
              case 429:
                return AJAX_ERROR_HANDLER_ACTIONS.STOP_RETRY
              default:
                return AJAX_ERROR_HANDLER_ACTIONS.CONTINUE_RETRY
            }
          },
          error_tracking_options: {
            endpoint_identifier: "regions_city_serviced_apartments_path",
          },
        },
      )
      .then(({data}: {data: { serviced_apartment_regions: Array<{ slug: string }> } }) => {
        const visible_options = [] as any[]

        // # hide all options that are not blank
        if (MobileOsDetection.isIOS()) {
          $area.find("option").prop("disabled", true)
        }
        else {
          $area.find("option").hide()
        }


        // #show valid ones
        data.serviced_apartment_regions.forEach((region) => {
          const $selected_option = $area.find(`option[data-city-serviced-apartments-region-slug=${region.slug}]`)

          if (MobileOsDetection.isIOS()) {
            $selected_option.prop("disabled", false)
          }
          else {
            $selected_option.show()
          }

          if ($selected_option.length === 0) {
            return
          }
          visible_options.push($selected_option.attr("value"))
        })

        if (visible_options.length > 0) {
          $area.val(visible_options[0])
        }
        else {
          $area.val("")
        }
      })
      .catch((reason_or_error) => {
        if (reason_or_error instanceof Error) {
          throw reason_or_error
        }

        const { response } = reason_or_error
        switch (response.status) {
          case 404: {
            return ({result_type: ResultTypeEnums.RESOURCE_NOT_FOUND})
          }
          case 429: {
            return ({result_type: ResultTypeEnums.TOO_MANY_REQUEST})
          }
          default:
            captureMessage(
              `Error occurred when using ajax with status <${(response.status || "unknown")}>`,
              {
                source_file_path:
                  "app/assets/javascripts/concepts/cities/concierge/serviced_apartments/index.ts",
              },
            )
        }
      })
      .done()
    })

    IntlTelInput.getIntlTelInput()
    .then((intlTelInput) => {
      WaitObjectByPathPromise("window._spacious_main_css_loaded")
      .then(() => {
        intlTelInput($contact_phone_number_input[0], {
          loadUtilsOnInit:    () => import("intl-tel-input/build/js/utils"),
          allowDropdown:      true,
          autoInsertDialCode: true,
          autoPlaceholder:    "polite",
          nationalMode:       false,
          separateDialCode:   true,

          initialCountry:     "auto",
          localizedCountries: (I18n.t("plugins.intl_tel_input.iso2_code") as any),
          preferredCountries: [
            "hk",
            "tw",
            "cn",
            "mo",
            "jp",
            "us",
            "gb",
          ],
          geoIpLookup: (callback: (c: string) => void) => {
            q_ajax_3({
              url:      "/my_country_code",
              method:   "GET",
              dataType: "json",
            })
            .then(({data}) => {
              const countryCode = (data?.country_code) ? data.country_code : ""
              callback(countryCode)
            })
            .catch(() => {
              // Do nothing
            })
            .done()
          },
        })


        $contact_phone_number_input.on("open:countrydropdown", () => {
          $("body").addClass(PAGE_EXPAND_CLASS)
        })

        $contact_phone_number_input.on("close:countrydropdown", () => {
          $("body").removeClass(PAGE_EXPAND_CLASS)
        })

        window.intlTelInputGlobals.loadUtils("https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.19/js/utils.js")
      })
      .done()
    })

    $form.on("submit", (e) => {
      e.preventDefault()
      const reject_promotions_input_val: boolean =
        $reject_promotions_input.is(":checked")

      const contact_phone_number_dial_code_text: string | null =
        $form.find(DEFAULT_SELECTOR.contact_phone_number_dial_code).text()

      const input_data = (serialize($form[0] as HTMLFormElement, {hash: true}) as any)

      input_data.city_serviced_apartments_request_record.contact_phone =
        Formatter.phoneNumber(
          input_data.city_serviced_apartments_request_record.contact_phone,
          contact_phone_number_dial_code_text,
        ) || ""

      clear_errors($el)

      $section.addClass("form-sending")

      q_ajax_3({
        url:    $form.attr("action"),
        method: "POST",
        data:   Object.assign(
          input_data,
          {
            reject_promotions: reject_promotions_input_val,
          },
        ),
      })
      .then(({data}) => {

        $section.removeClass("form-sending")
        $section.addClass("form-sent")
        $form.find("input").prop({disabled: true})
        $form.find("select").prop({disabled: true})
        $form.find("textarea").prop({disabled: true})
        Authentication_remote_state.refreshAndUpdateComponentPromise().done()
        Google_Event.track({
          category: "SA Concierge",
          action:   "Submit",
          options:  {
            eventLabel: "Success",
          },
        })

        GA4_Event.track({
          event_name:   "sa_concierge_submitted",
          options:    {
            page: PageInstance.currentPageNameForTracking(),
          },
        })

        q_ajax_3({
          url:  Routes.apps_spacious_website_submission_path(I18n.locale, {
            success: true,
          }),
          method:   "GET",
          dataType: "html",
        })
        .then(({data: indicator_html}) => {
          $indicator.html(indicator_html)
          StickyNavbarHandler.scrollTo($indicator, {
            duration: 0,
          })
        })
        .done()
      })
      .catch(({response}) => {
        $section.removeClass("form-sending")
        $section.removeClass("form-sent")
        render_errors($el, response)
        if (response.status === 409){
          const email = $email.find("input").val()
          const error_msg = I18n.t("js.app.concepts.cities.concierge.shared.form.errors.existing_contact_email", {email: email})
          Notifier.showWarning(error_msg)
        }
      })
      .done()
    })

    const popover_options = Object.assign(
      {},
      DEFAULT_POPOVER_OPTIONS,
      options == null ? {} : options.popover_options,
      {
        container:  DEFAULT_SELECTOR.scope,
        content:    I18n.t("concepts.cities.concierge.shared.footer.tooltip_html",
                           {
                             privacy_link: Routes.privacy_policy_page_path({locale: I18n.locale}),
                           },
        ),
        html:       "true",
      },
    )

    $tooltip.popover(popover_options)

    Authentication_manager.on("sign_up:success:action", () => {
      $footer.addClass("hide-reject_promotions")
      $reject_promotions_container.html("")
    })

    Authentication_manager.on("sign_in:success:action", () => {
      $footer.addClass("hide-reject_promotions")
      $reject_promotions_container.html("")
    })
  })



  Pikaday.init()
}

function clear_errors($el: JQuery) {
  $el.find(".cell--cities--concierge__form--input-container").removeClass("error")
}

function render_errors($el: JQuery, response: Response) {
  response.json().then((responseJSON) => {
    if (responseJSON == null) { return }
    const error_list = responseJSON.error_list

    Object.entries(error_list).forEach(([key, val]) => {
      const $selector = $el.find(`.cell--cities--concierge__form--input-container__${key}`)
      const error_message = I18n.t(`concepts.cities.concierge.shared.form.errors.${key}.${val}`)
      $selector.addClass("error")
      $selector.find(DEFAULT_SELECTOR.error_container).html(error_message)
    })
  })
}


export default {init}
